import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { WebSiteComponent } from './website/web-site.component';
import { SurveyComponent } from './survey/survey.component';
import { DataResourceComponent } from './data-resource/data-resource.component';
import { ContentComponent } from './content/content.component';
import { BlogComponent } from './blog/blog.component'
import { ForumsComponent } from './forums/forums.component';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { NbMenuItem } from '@nebular/theme';

export const routes:Routes = [
  {
    path:'',
    component:WebSiteComponent,
  },
  {
    path:'websites',
    component:WebSiteComponent,
  },
  {
    path:'survey',
    component:SurveyComponent,
  },
  {
    path:'content',
    component:ContentComponent,
  },
  {
    path:'data-resource',
    component:DataResourceComponent,
  },
  {
    path:'blog',
    component:BlogComponent,
  },
  {
    path:'forums',
    component:ForumsComponent,
  }
  

];

const path:string = "cms";
const MENU_ITEMS:NbMenuItem[] = [
  {
    title: 'Websites',
    icon: 'globe-outline',
    link: '/admin/cms/websites',
    home: true,
  },
  {
    title: 'Content',
    icon: 'file-text-outline',
    link: '/admin/cms/content',
    home: true,
  },
  {
    title: 'Survey',
    icon: 'clipboard-outline',
    link: '/admin/cms/survey',
  },
  {
    title: 'Blogs',
    icon: 'book-outline',
    link: '/admin/cms/blog',
  },
  {
    title: 'Forum',
    icon: 'people-outline',
    link: '/admin/cms/forums',
  },
  {
    title: 'Data Resource',
    icon: 'cube-outline',
    link: '/admin/cms/data-resource',
  },
  {
    title: 'Gallery',
    icon: 'color-palette-outline',
    link: '/pages/iot-dashboard',
  },
  {
    title: 'Editors',
    icon: 'text-outline',
    children: [
      {
        title: 'TinyMCE',
        link: '/pages/editors/tinymce',
      },
      {
        title: 'CKEditor',
        link: '/pages/editors/ckeditor',
      },
    ],
  },
  {
    title: 'Tables & Data',
    icon: 'grid-outline',
    children: [
      {
        title: 'Smart Table',
        link: '/pages/tables/smart-table',
      },
      {
        title: 'Tree Grid',
        link: '/pages/tables/tree-grid',
      },
    ],
  },

];

const headerTitle:string = "CMS";
const menuTag:string = "cmsMenu"


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    UbsViewContainersModule
  ],
  exports: [RouterModule,UbsViewContainersModule],
})
export class CmsRoutingModule {
  menuAndTitleOptions = {path:path,menuItems:MENU_ITEMS,headerTitle:headerTitle,menuTag:menuTag};
  constructor(private viewContainerService:ViewContainersService){
    let currentItems = this.viewContainerService.menuAndTitleOptions$.getValue();
    console.log(currentItems);
    let updated = currentItems.concat(this.menuAndTitleOptions);
    this.viewContainerService.menuAndTitleOptions$.next(updated);
    //this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }
 }
